// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___2GE3V","type":"styles__type___lUkIH","description":"styles__description___1p_0m","form":"styles__form___3UHpo","button":"styles__button___1LrZv"};